// extracted by mini-css-extract-plugin
module.exports = {"headerCell":"styles_headerCell__3IeLW","slideInFromRight":"styles_slideInFromRight__V6db3"};